import Service from "../../services";

const qualityModule = {
  namespaced: true,
  state: {
    filter: [],
    result: [],
    status: {
      date: true,
      graph: false,
    },
    test_item: [],
    qc_name: [],
    lot_no: [],
  },
  mutations: {
    SET_STATUS: (state, data) => {
      (state.status.date = data.date), (state.status.graph = data.graph);
    },
    FILTER_RESULT: (state, data) => {
      state.filter = data;
    },
    SET_RESULT: (state, data) => {
      state.result = data;
    },
    SET_TEST: (state, data) => {
      state.test_item = data;
    },
    SET_QC: (state, data) => {
      state.qc_name = data;
    },
    SET_LOT: (state, data) => {
      state.lot_no = data;
    },
  },
  actions: {
    filterQuality(context, payload) {
      Service.qualityControl.getFilterQuality(payload).then((res) => {
        context.commit("FILTER_RESULT", res);
      });
    },
    qualityDate(context, payload) {
      Service.qualityControl.getQualityDate(payload).then((res) => {
        context.commit("SET_RESULT", res);
      });
    },

    changeStatus({ commit }, payload) {
      commit("SET_STATUS", payload);
    },
    approveQuality(context, payload) {
      Service.qualityControl.approveQuality(payload).then((res) => {
        context.commit("SET_RESULT", res);
      });
    },
    setTestItem(context) {
      Service.qualityControl.getTestItemAll().then((res) => {
        context.commit("SET_TEST", res);
      });
    },
    setQCName(context) {
      Service.qualityControl.getQCNameAll().then((res) => {
        context.commit("SET_QC", res);
      });
    },
    setLotNo(context) {
      Service.qualityControl.getLotNumberAll().then((res) => {
        context.commit("SET_LOT", res);
      });
    },
  },
  getters: {
    getQualityDate(state) {
      return state.result;
    },
    getFilterQuality(state) {
      return state.filter;
    },
    getStatus(state) {
      return state.status;
    },
    getTestItemAll(state) {
      return state.test_item;
    },
    getQCNameAll(state) {
      return state.qc_name;
    },
    getLotNumberAll(state) {
      return state.lot_no;
    },
  },
};
export default qualityModule;
